module.exports = __webpack_public_path__ + "img/Logos-21.ed786b93.png";